<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">컨셉 수정하기</p>

    <v-sheet class="mt-2 px-4">
      <!-- 상품타입 -->
      <v-select :items="select_list.productType" class="rounded-10" label="상품타입" dense outlined v-model="updateItem.productType"></v-select>

      <v-divider class="my-4"></v-divider>

      <v-sheet v-if="!url" outlined class="rounded-10 pa-2 mt-2">
        <v-img :src="'/upload/concept/thumbnail_image/' + updateItem.thumbnail_image"></v-img>
      </v-sheet>

      <!-- 이미지 편집/미리보기 -->
      <v-sheet v-if="url" outlined class="rounded-10 pa-2 mt-2">
        <clipper-basic :src="url" ref="clipper" class="my-clipper" :ratio="4 / 2.5" :init-width="100">
          <div class="placeholder d-flex align-center justify-center" slot="placeholder">
            <span class="text-caption grey--text">이미지 미리보기</span>
          </div>
        </clipper-basic>
      </v-sheet>

      <!-- 이미지 첨부 -->
      <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile" @dragover.prevent>
        <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="이미지" v-model="uploadImage" @change="onFileChange()">
          <template v-slot:prepend-inner>
            <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
          </template>
        </v-file-input>
      </v-sheet>

      <!-- 기본 패턴 이미지 -->
      <v-sheet v-if="!url2" outlined class="rounded-10 pa-2 mt-2">
        <v-img :src="'/upload/concept/thumbnail_image/' + updateItem.pattern_1_image"></v-img>
      </v-sheet>

      <v-sheet v-if="url2" outlined class="rounded-10 pa-2 mt-2">
        <clipper-basic :src="url2" ref="clipper2" class="my-clipper" :ratio="2.5 / 3" :init-width="100">
          <div class="placeholder d-flex align-center justify-center" slot="placeholder">
            <span class="text-caption grey--text">기본 패턴 이미지 미리보기</span>
          </div>
        </clipper-basic>
      </v-sheet>

      <v-sheet class="mt-4 mb-4" @drop.prevent="addDropFile2" @dragover.prevent>
        <v-file-input class="rounded-10" outlined dense show-size hide-details prepend-icon color="primary" label="기본 패턴 이미지" v-model="uploadImage2" @change="onFileChange2()">
          <template v-slot:prepend-inner>
            <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
          </template>
        </v-file-input>
      </v-sheet>

      <!-- 추가 패턴 이미지 (동적) -->
      <v-divider class="my-4"></v-divider>
      <div class="d-flex align-center justify-space-between mb-2">
        <span class="font-weight-bold">추가 패턴 이미지</span>
        <v-btn small color="primary" depressed @click="addPatternImage">
          <v-icon small left>mdi-plus</v-icon>
          패턴 추가
        </v-btn>
      </div>

      <v-sheet v-for="(pattern, index) in patternOthersImages" :key="pattern.id" class="mb-4 pa-3" outlined>
        <div class="d-flex align-center justify-space-between mb-2">
          <span class="text-caption grey--text">패턴 {{ index + 1 }}</span>
          <v-btn x-small color="red" text @click="removePatternImage(index)">
            <v-icon small>mdi-delete</v-icon>
            삭제
          </v-btn>
        </div>

        <!-- 기존 이미지 표시 -->
        <v-sheet v-if="!pattern.url && pattern.image" outlined class="rounded-10 pa-2 mb-2">
          <v-img height="150" :src="'/upload/concept/thumbnail_image/' + pattern.image"></v-img>
        </v-sheet>

        <!-- 새 이미지 크롭 -->
        <v-sheet v-if="pattern.url" outlined class="rounded-10 pa-2">
          <clipper-basic :src="pattern.url" :ref="`clipperOther${index}`" class="my-clipper" :ratio="2.5 / 3" :init-width="100">
            <div class="placeholder d-flex align-center justify-center" slot="placeholder">
              <span class="text-caption grey--text">추가 패턴 {{ index + 1 }} 미리보기</span>
            </div>
          </clipper-basic>
        </v-sheet>

        <v-sheet class="mt-2" @drop.prevent="(e) => addDropFileOther(e, index)" @dragover.prevent>
          <v-file-input
            class="rounded-10"
            outlined
            dense
            show-size
            hide-details
            prepend-icon
            color="primary"
            :label="`추가 패턴 ${index + 1} 이미지`"
            v-model="pattern.file"
            @change="onFileChangeOther(index)"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mr-1" color="primary">mdi-image-filter-hdr</v-icon>
            </template>
          </v-file-input>
        </v-sheet>
      </v-sheet>

      <v-divider class="my-4"></v-divider>

      <v-text-field class="rounded-10" label="제목(한글)" dense outlined v-model="updateItem.title"></v-text-field>
      <v-text-field class="rounded-10" label="제목(영어)" dense outlined v-model="updateItem.title_en"></v-text-field>
      <v-text-field class="rounded-10" label="제목(일어)" dense outlined v-model="updateItem.title_jp"></v-text-field>
      <v-autocomplete class="rounded-10" label="태그" dense outlined multiple :items="select_list.tag" v-model="updateItem.tag"></v-autocomplete>
      <v-text-field class="rounded-10" label="새도우" dense outlined v-model="updateItem.shadow_json"></v-text-field>
      <v-select :items="select_list.status" class="rounded-10" label="상태" dense outlined v-model="updateItem.status"></v-select>
      <v-text-field class="rounded-10" label="순서" dense outlined type="number" v-model="updateItem.order"></v-text-field>

      <FundingSettingsSection
        ref="fundingSettings"
        v-model="fundingSettings"
        :concept-id="updateItem.id"
        :concept-title="updateItem.title"
        :images="fundingImages"
      />

      <!-- 프리미엄 컨셉 설명 (Premium only) -->
      <v-sheet v-if="updateItem.productType === 'premium'" class="mt-4 pa-4" outlined>
        <div class="font-weight-bold text-subtitle-1 mb-4">프리미엄 컨셉 설명 (선택사항)</div>

        <!-- Title -->
        <div class="mb-4">
          <div class="font-weight-bold text-body-2 mb-2">큰 타이틀</div>
          <v-text-field class="rounded-10" label="한글" dense outlined v-model="conceptDesc.title.kr"></v-text-field>
          <v-text-field class="rounded-10" label="영어" dense outlined v-model="conceptDesc.title.en"></v-text-field>
          <v-text-field class="rounded-10" label="일어" dense outlined v-model="conceptDesc.title.jp"></v-text-field>
        </div>

        <!-- SubTitle -->
        <div class="mb-4">
          <div class="font-weight-bold text-body-2 mb-2">작은 타이틀</div>
          <v-textarea class="rounded-10" label="한글" dense outlined rows="2" v-model="conceptDesc.subTitle.kr"></v-textarea>
          <v-textarea class="rounded-10" label="영어" dense outlined rows="2" v-model="conceptDesc.subTitle.en"></v-textarea>
          <v-textarea class="rounded-10" label="일어" dense outlined rows="2" v-model="conceptDesc.subTitle.jp"></v-textarea>
        </div>

        <!-- StoryLine -->
        <div class="mb-4">
          <div class="font-weight-bold text-body-2 mb-2">스토리 설명</div>
          <v-textarea class="rounded-10" label="한글" dense outlined rows="3" v-model="conceptDesc.storyLine.kr"></v-textarea>
          <v-textarea class="rounded-10" label="영어" dense outlined rows="3" v-model="conceptDesc.storyLine.en"></v-textarea>
          <v-textarea class="rounded-10" label="일어" dense outlined rows="3" v-model="conceptDesc.storyLine.jp"></v-textarea>
        </div>

        <!-- Closing -->
        <div>
          <div class="font-weight-bold text-body-2 mb-2">마무리 설명</div>
          <v-textarea class="rounded-10" label="한글" dense outlined rows="3" v-model="conceptDesc.closing.kr"></v-textarea>
          <v-textarea class="rounded-10" label="영어" dense outlined rows="3" v-model="conceptDesc.closing.en"></v-textarea>
          <v-textarea class="rounded-10" label="일어" dense outlined rows="3" v-model="conceptDesc.closing.jp"></v-textarea>
        </div>
      </v-sheet>

      <!-- 본문 -->
      <v-divider></v-divider>
      <v-sheet>
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
          <v-btn color="primary" depressed outlined small @click="clear('ko')">삭제</v-btn>
        </div>
        <TipTapWriter :key="componentKey" class="tiptap_style" :options="options" />
      </v-sheet>

      <v-sheet class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
          <v-btn color="primary" depressed outlined small @click="clear('en')">삭제</v-btn>
        </div>
        <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en' + en.componentKey" />
      </v-sheet>

      <v-sheet class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold text-h6 ml-4 mt-4">일어</div>
          <v-btn color="primary" depressed outlined small @click="clear('jp')">삭제</v-btn>
        </div>
        <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp' + jp.componentKey" />
      </v-sheet>
    </v-sheet>
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="updateSubmit()">
        <v-icon small left>mdi-database-edit-outline</v-icon>
        수정하기
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import { AllTag, Tags } from "@/constant"
import FundingSettingsSection from "./FundingSettingsSection"
import {
  createFundingSettings,
  loadFundingSettings,
  saveFundingSettings,
} from "./fundingSettings"

export default {
  props: ["updateItem_import"],

  components: {
    TipTapWriter,
    FundingSettingsSection,
  },

  data: () => ({
    select_list: {
      tag: Tags.map((e) => e.title),
      status: ["노출", "숨김"],
      productType: [
        { text: "메이커샷", value: "makershot" },
        { text: "프리미엄", value: "premium" },
      ],
    },

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    uploadImage: {},
    url: "",

    uploadImage2: {},
    url2: "",

    patternOthersImages: [],
    fundingSettings: createFundingSettings(),
    fundingSettingsExists: false,

    updateItem: {
      pattern_1_image: "",
      productType: "makershot",
    },

    conceptDesc: {
      title: { kr: "", en: "", jp: "" },
      subTitle: { kr: "", en: "", jp: "" },
      storyLine: { kr: "", en: "", jp: "" },
      closing: { kr: "", en: "", jp: "" },
    },
    originalStoryLine: { kr: "", en: "", jp: "" },
    storyHash: null,
  }),

  computed: {
    fundingImages() {
      return [
        {
          key: "thumbnail",
          label: "썸네일",
          src: this.url || this.imagePath(this.updateItem.thumbnail_image),
        },
        {
          key: "pattern_1",
          label: "기본 패턴",
          src: this.url2 || this.imagePath(this.updateItem.pattern_1_image),
        },
        ...this.patternOthersImages.map((pattern, index) => ({
          key: `pattern_other_${index + 1}`,
          label: `추가 패턴 ${index + 1}`,
          src: pattern.url || this.imagePath(pattern.image),
        })),
      ]
    },
  },

  mounted() {
    this.updateItem = this.updateItem_import
    console.log(this.updateItem_import)
    if (this.updateItem_import.tag) {
      let test = this.updateItem_import.tag.split(",")
      this.updateItem.tag = test
    } else {
      this.updateItem.tag = ""
    }
    this.load()
    this.loadFunding()
  },

  watch: {
    updateItem_import() {
      this.updateItem = this.updateItem_import
      if (this.updateItem_import.tag) {
        let test = this.updateItem_import.tag.split(",")
        this.updateItem.tag = test
      } else {
        this.updateItem.tag = ""
      }
      this.load()
      this.loadFunding()
    },
  },

  methods: {
    conceptDescriptionForSave() {
      const description = { ...this.conceptDesc }
      const format = { ...(description.storyFormat || {}) }
      for (const lang of ["kr", "en", "jp"]) {
        const current = String(description.storyLine?.[lang] || "")
        if (current.trim() && current !== String(this.originalStoryLine[lang] || "")) {
          if (format[lang] !== "lafia-story-v2") format[lang] = "lafia-story-v1"
        }
      }
      if (Object.keys(format).length) description.storyFormat = format
      return description
    },
    imagePath(filename) {
      return filename ? `/upload/concept/thumbnail_image/${filename}` : ""
    },

    async loadFunding() {
      if (!this.updateItem.id) return
      try {
        const result = await loadFundingSettings(this.$http, this.updateItem.id)
        this.fundingSettings = result.funding
        this.fundingSettingsExists = result.exists
      } catch (error) {
        this.fundingSettings = createFundingSettings()
        this.fundingSettingsExists = false
      }
    },

    async saveFunding() {
      if (!this.fundingSettings.funding_enabled && !this.fundingSettingsExists) return
      await saveFundingSettings(
        this.$http,
        this.updateItem.id,
        this.fundingSettings
      )
      this.fundingSettingsExists = true
    },

    load() {
      console.log("conceptId: " + this.updateItem.id)
      this.$http
        .post("/api/concept/select/specific", {
          params: {
            id: this.updateItem.id,
          },
        })
        .then((res) => {
          console.log(res.data)
          if (res.data && res.data.length > 0) {
            const data = res.data[0]

            // 컨텐츠 로드
            if (data.content) {
              this.options.content = data.content
              this.componentKey++

              this.en.options.content = data.content_en
              this.en.componentKey++

              this.jp.options.content = data.content_jp
              this.jp.componentKey++
            }

            // productType 로드
            if (data.productType) {
              this.updateItem.productType = data.productType
            }

            // pattern_others_image 로드
            if (data.pattern_others_image && Array.isArray(data.pattern_others_image)) {
              this.patternOthersImages = data.pattern_others_image.map((pattern) => ({
                id: pattern.id,
                image: pattern.image,
                order: pattern.order,
                file: null,
                url: "",
              }))
            }

            // concept_desc 로드
            if (data.concept_desc) {
              try {
                const parsed = typeof data.concept_desc === "string" ? JSON.parse(data.concept_desc) : data.concept_desc
                this.storyHash = data.storyHash
                this.originalStoryLine = { ...(parsed.storyLine || {}) }
                this.conceptDesc = {
                  ...parsed,
                  title: parsed.title || { kr: "", en: "", jp: "" },
                  subTitle: parsed.subTitle || { kr: "", en: "", jp: "" },
                  storyLine: parsed.storyLine || { kr: "", en: "", jp: "" },
                  closing: parsed.closing || { kr: "", en: "", jp: "" },
                }
              } catch (e) {
                console.error("Failed to parse concept_desc:", e)
              }
            }
          }
        })
    },

    // 파일 드래그앤드롭
    addDropFile(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage = e.dataTransfer.files[0]
      this.url = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange() {
      const file = this.uploadImage
      this.url = URL.createObjectURL(file)
    },

    // 파일 드래그앤드롭
    addDropFile2(e) {
      const file = e.dataTransfer.files[0]
      this.uploadImage2 = e.dataTransfer.files[0]
      this.url2 = URL.createObjectURL(file)
    },

    // 파일 선택시 이미지 표시
    onFileChange2() {
      const file = this.uploadImage2
      this.url2 = URL.createObjectURL(file)
    },

    // 추가 패턴 이미지 추가
    addPatternImage() {
      this.patternOthersImages.push({
        id: `pattern_other_${this.patternOthersImages.length + 1}`,
        file: null,
        url: "",
        image: "",
        order: this.patternOthersImages.length + 1,
      })
    },

    // 추가 패턴 이미지 제거
    removePatternImage(index) {
      this.patternOthersImages.splice(index, 1)
      // order 재정렬
      this.patternOthersImages.forEach((pattern, idx) => {
        pattern.order = idx + 1
        pattern.id = `pattern_other_${idx + 1}`
      })
    },

    // 추가 패턴 드래그앤드롭
    addDropFileOther(e, index) {
      const file = e.dataTransfer.files[0]
      this.patternOthersImages[index].file = file
      this.patternOthersImages[index].url = URL.createObjectURL(file)
    },

    // 추가 패턴 파일 선택시 이미지 표시
    onFileChangeOther(index) {
      const file = this.patternOthersImages[index].file
      if (file) {
        this.patternOthersImages[index].url = URL.createObjectURL(file)
      }
    },

    // 이미지 업로드
    imageUpload: _.debounce(async function () {
      // 썸네일 이미지 업로드 (변경된 경우만)
      if (this.url) {
        const canvas = this.$refs.clipper.clip()
        var imgDataUrl = canvas.toDataURL("image/webp", 0.5)
        var binaryData = atob(imgDataUrl.split(",")[1])
        var array = []
        for (var i = 0; i < binaryData.length; i++) {
          array.push(binaryData.charCodeAt(i))
        }
        var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
        var formData = new FormData()
        formData.append("image", file)

        await this.$http
          .post("/api/image/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              type: "concept/thumbnail_image",
            },
          })
          .then((res) => {
            this.updateItem.thumbnail_image = res.data
          })
      }

      // 기본 패턴 이미지 업로드 (변경된 경우만)
      if (this.url2) {
        const canvas2 = this.$refs.clipper2.clip()
        var imgDataUrl2 = canvas2.toDataURL("image/webp", 0.5)
        var binaryData2 = atob(imgDataUrl2.split(",")[1])
        var array2 = []
        for (var i = 0; i < binaryData2.length; i++) {
          array2.push(binaryData2.charCodeAt(i))
        }
        var file2 = new File([new Uint8Array(array2)], "filename.png", { type: "image/png" })
        var formData2 = new FormData()
        formData2.append("image", file2)

        await this.$http
          .post("/api/image/upload", formData2, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              type: "concept/thumbnail_image",
            },
          })
          .then((res) => {
            this.updateItem.pattern_1_image = res.data
          })
      }

      // 추가 패턴 이미지 업로드
      const patternOthersData = []
      for (let index = 0; index < this.patternOthersImages.length; index++) {
        const pattern = this.patternOthersImages[index]

        // 새로 업로드된 파일이 있는 경우
        if (pattern.file && pattern.url) {
          const clipperRef = this.$refs[`clipperOther${index}`]
          if (clipperRef && clipperRef[0]) {
            const canvas = clipperRef[0].clip()
            var imgDataUrl = canvas.toDataURL("image/webp", 0.5)
            var binaryData = atob(imgDataUrl.split(",")[1])
            var array = []
            for (var i = 0; i < binaryData.length; i++) {
              array.push(binaryData.charCodeAt(i))
            }
            var file = new File([new Uint8Array(array)], "filename.png", { type: "image/png" })
            var formData = new FormData()
            formData.append("image", file)

            await this.$http
              .post("/api/image/upload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                params: {
                  type: "concept/thumbnail_image",
                },
              })
              .then((res) => {
                patternOthersData.push({
                  id: pattern.id,
                  image: res.data,
                  order: pattern.order,
                })
              })
          }
        } else if (pattern.image) {
          // 기존 이미지 유지
          patternOthersData.push({
            id: pattern.id,
            image: pattern.image,
            order: pattern.order,
          })
        }
      }

      console.log(this.updateItem.status)

      // concept_desc JSON 생성 (프리미엄 타입일 때만)
      let conceptDescJson = null
      if (this.updateItem.productType === "premium") {
        conceptDescJson = JSON.stringify(this.conceptDescriptionForSave())
      }

      // DB 입력
      await this.$http
        .post("/api/concept/update", {
          params: {
            thumbnail_image: this.updateItem.thumbnail_image,
            pattern_1_image: this.updateItem.pattern_1_image,
            pattern_others_image: patternOthersData,
            productType: this.updateItem.productType,
            title: this.updateItem.title,
            title_en: this.updateItem.title_en,
            title_jp: this.updateItem.title_jp,
            content: this.options.content,
            content_en: this.en.options.content,
            content_jp: this.jp.options.content,
            tag: this.updateItem.tag.toString(),
            status: this.updateItem.status,
            id: this.updateItem.id,
            shadow_json: this.updateItem.shadow_json,
            order: Number(this.updateItem.order),
            concept_desc: conceptDescJson,
            expectedStoryHash: this.storyHash,
          },
        })
        .then(async (res) => {
          if (res.data.affectedRows) {
            this.storyHash = res.data.storyHash
            this.conceptDesc.storyFormat = this.conceptDescriptionForSave().storyFormat
            this.originalStoryLine = { ...this.conceptDesc.storyLine }
            try {
              await this.saveFunding()
              alert("컨셉이 정상적으로 수정되었습니다")
            } catch (error) {
              alert("컨셉은 수정됐지만 펀딩 설정은 저장되지 않았습니다. 다시 저장해 주세요.")
            }
            this.options.content == ""
            this.$emit("close")
          }
        })
    }, 500),

    // 목록
    async updateSubmit() {
      const fundingErrors = this.$refs.fundingSettings
        ? this.$refs.fundingSettings.validate()
        : []
      if (fundingErrors.length) {
        alert(fundingErrors[0])
        return
      }

      // 제목 검증
      if (this.updateItem.title == "") {
        alert("제목을 입력해주세요")
        return
      }

      // 태그 검증
      if (this.updateItem.tag.toString() == "") {
        alert("태그를 입력해주세요")
        return
      }

      // shadow 검증
      else if (this.updateItem.shadow_json == "") {
        alert("새도우값을 입력해주세요")
        return
      }

      // 상태 검증
      if (this.updateItem.status == "") {
        alert("상태를 입력해주세요")
        return
      }

      // 이미지 변경 여부 확인
      const hasImageChange = this.url || this.url2 || this.patternOthersImages.some((p) => p.file)

      if (!hasImageChange) {
        // 이미지 변경 없이 데이터만 업데이트
        const patternOthersData = this.patternOthersImages.map((pattern) => ({
          id: pattern.id,
          image: pattern.image,
          order: pattern.order,
        }))

        // concept_desc JSON 생성 (프리미엄 타입일 때만)
        let conceptDescJson = null
        if (this.updateItem.productType === "premium") {
          conceptDescJson = JSON.stringify(this.conceptDescriptionForSave())
        }

        this.$http
          .post("/api/concept/update", {
            params: {
              thumbnail_image: this.updateItem.thumbnail_image,
              pattern_1_image: this.updateItem.pattern_1_image,
              pattern_others_image: patternOthersData,
              productType: this.updateItem.productType,
              title: this.updateItem.title,
              title_en: this.updateItem.title_en,
              title_jp: this.updateItem.title_jp,
              content: this.options.content,
              content_en: this.en.options.content,
              content_jp: this.jp.options.content,
              tag: this.updateItem.tag.toString(),
              status: this.updateItem.status,
              shadow_json: this.updateItem.shadow_json,
              order: this.updateItem.order,
              id: this.updateItem.id,
              concept_desc: conceptDescJson,
              expectedStoryHash: this.storyHash,
            },
          })
          .then(async (res) => {
            console.log(res)
            if (res.data.affectedRows) {
              this.storyHash = res.data.storyHash
              this.conceptDesc.storyFormat = this.conceptDescriptionForSave().storyFormat
              this.originalStoryLine = { ...this.conceptDesc.storyLine }
              try {
                await this.saveFunding()
                alert("컨셉이 정상적으로 수정되었습니다")
              } catch (error) {
                alert("컨셉은 수정됐지만 펀딩 설정은 저장되지 않았습니다. 다시 저장해 주세요.")
              }
              this.options.content == ""
              this.$emit("close")
            }
          })
      } else {
        await this.imageUpload()
      }
    },

    clear(lang = "ko") {
      if (lang === "ko") {
        this.options.content = null
        this.componentKey++
      } else if (lang === "en") {
        this.en.options.content = null
        this.en.componentKey++
      } else if (lang === "jp") {
        this.jp.options.content = null
        this.jp.componentKey++
      }
    },
  },
}
</script>
<style scoped>
.my-clipper {
  width: 100%;
}

.placeholder {
  width: 100%;
  height: 150px;
}
</style>
